// src/components/Scheduler.jsx
import React from 'react';
import * as PropTypes from 'prop-types';
import {
  Scheduler as KendoScheduler,
  DayView,
  WeekView,
  WorkWeekView,
  MonthView,
} from '@progress/kendo-react-scheduler';
import { FormWithCustomDialog } from './form/CustomForm';

export const Scheduler = (props) => {
  const { data, modelFields, resources, onDataChange, defaultView, onViewChange, view } = props;

  const defaultDate = new Date();

  const CustomForm = (formProps) => (
    <FormWithCustomDialog
      {...formProps}
      fields={modelFields}
      resources={resources}
    />
  );

  console.log('Scheduler rendering with defaultView:', defaultView, 'view:', view);

  return (
    <KendoScheduler
      data={data}
      modelFields={modelFields}
      resources={resources}
      timezone={'Etc/UTC'}
      defaultDate={defaultDate}
      defaultView={defaultView}
      view={view}
      onViewChange={onViewChange}
      onDataChange={onDataChange}
      editable={{
        add: true,
        remove: true,
        drag: true,
        resize: true,
        edit: true,
      }}
      form={CustomForm}
    >
      <DayView
        startTime="00:00"
        endTime="23:59"
        slotDuration={60} // 60 Minuten pro Slot
        slotDivisions={1} // 1 Unterteilung pro Stunde
        workDayStart="00:00" // Arbeitsstart auf 00:00 setzen
        workDayEnd="23:59" // Arbeitsende auf 23:59 setzen
        showWorkHours={false} // Arbeitszeitbeschränkung deaktivieren
      />
      <WorkWeekView
        startTime="00:00"
        endTime="23:59"
        slotDuration={60}
        slotDivisions={1}
        workDayStart="00:00"
        workDayEnd="23:59"
        showWorkHours={false}
        numberOfDays={7}
      />
      <WeekView
        startTime="00:00"
        endTime="23:59"
        slotDuration={60}
        slotDivisions={1}
        workDayStart="00:00"
        workDayEnd="23:59"
        showWorkHours={false}
      />
      <MonthView />
    </KendoScheduler>
  );
};

Scheduler.displayName = 'Scheduler';
Scheduler.propTypes = {
  data: PropTypes.array,
  resources: PropTypes.array,
  modelFields: PropTypes.object,
  defaultView: PropTypes.string,
  view: PropTypes.string,
  onViewChange: PropTypes.func,
};